import allArtistComments from "../data/allArtistComments.json";
import "./comment.css";

const dayList = Object.keys(allArtistComments);

const imgUrl = {
  20240705:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/songbird-resize.png",
  20241002:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/steady-resize.png",
  20250122:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/miracle.JPG",
  20250414:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250416:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250417:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250418:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250419:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250420:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/poppop-resize.png",
  20250812:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/surf-resize.png",
  20250813:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/surf-resize.png",
  20250814:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/surf-resize.png",
  20250816:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/surf-resize.png",
  20250901:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250902:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250903:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250905:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250906:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250907:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250908:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20250915:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20251104:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/color-resize.png",
  20260420:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20260421:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20260422:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20260423:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20260424:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20260425:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/odetolove-resize.jpg",
  20261012:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261013:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261014:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261015:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261016:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261017:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261018:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261019:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261020:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
  20261021:
    "https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/ispy-resize.jpeg",
};

const albumName = {
  20240705: "songbird",
  20241002: "steady",
  20250122: "miracle",
  20250414: "poppop",
  20250416: "poppop",
  20250417: "poppop",
  20250418: "poppop",
  20250419: "poppop",
  20250420: "poppop",
  20250812: "surf",
  20250813: "surf",
  20250814: "surf",
  20250816: "surf",
  20250901: "color",
  20250902: "color",
  20250903: "color",
  20250905: "color",
  20250906: "color",
  20250907: "color",
  20250908: "color",
  20250915: "color",
  20251104: "color",
  20260420: "odetolove",
  20260421: "odetolove",
  20260422: "odetolove",
  20260423: "odetolove",
  20260424: "odetolove",
  20260425: "odetolove",
  20261012: "ispy",
  20261013: "ispy",
  20261014: "ispy",
  20261015: "ispy",
  20261016: "ispy",
  20261017: "ispy",
  20261018: "ispy",
  20261019: "ispy",
  20261020: "ispy",
  20261021: "ispy",
};

const DateSelectList = ({ selectedDay, setSelectedDay }) => {
  return (
    <div
      style={{
        width: "400px",
        justifyContent: "center",
        height: "100dvh",
        overflow: "hidden",
      }}
    >
      <div
        className={`date-select-image ${albumName[selectedDay]}`}
        style={{
          backgroundImage: `url(${imgUrl[selectedDay]})`,
        }}
      >
        <div className="date-select-image-text">
          날짜를
          <br />
          선택해주세요
        </div>
      </div>
      <div className={`date-select-container ${albumName[selectedDay]}`}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, auto)" /* 한 줄에 5개 */,
            gap: "8px",
            padding: "10px",
          }}
        >
          {dayList.map((date) => (
            <div
              key={date}
              onClick={() => {
                setSelectedDay(date);
              }}
              style={{
                cursor: "pointer",
                textAlign: "center",
                backgroundColor:
                  date === selectedDay
                    ? "rgba(255,255,255,0.3)"
                    : "transparent",
                color: "white",
                userSelect: "none",
                border: "1px solid white",
                borderRadius: "1rem",
                justifyContent: "center",
                alignItems: "center",
                padding: "8px",
                fontSize: "14px",
              }}
            >
              {`${date.slice(0, 4)}.${date.slice(4, 6)}.${date.slice(6, 8)}`}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DateSelectList;
